module.exports = __webpack_public_path__ + "static/media/b.76645790.jpg";